module.exports = __webpack_public_path__ + "img/WAPPR.fe1c2931.svg";